// extracted by mini-css-extract-plugin
export default {"rotation":"Rotation_rotation__c3eeb","values":"Rotation_values__oojqZ","default":"Rotation_default__I0q7I"};